import sectionsConfig from "./ab-sections.config.json";
const sectionsWithDataProps = sectionsConfig.sections.filter((section) => section.wrapWithData).map((section) => section.name);
export default sectionsWithDataProps;
